import useFileDownload from 'modules/FileManagerV2/hooks/ui/useFileDownload';
import React from 'react';
import GlobalTooltip from 'components/GlobalTooltip';
import { useFileManagerContext } from 'modules/FileManagerV2/context/FileManagerContext';

function FileDownload(props) {
  const { downloadFile, downloadFolder } = useFileDownload();
  const { rowData, isFromFilePreviewModal, filePreviewModalIconClassName, onDownloadComplete } = props;
  const { isClientFileManager, fileManagerFilters, caseDetails } = useFileManagerContext();

  const iconClassName =
    isFromFilePreviewModal && filePreviewModalIconClassName ? filePreviewModalIconClassName : 'icon-save text-primary-main';

  const handleDownload = async () => {
    if (rowData.entry_type === 'folder') {
      const caseId = rowData?.case_id || (isClientFileManager ? fileManagerFilters?.case?.id : caseDetails?.case_id);
      await downloadFolder(rowData, caseId);
    } else {
      await downloadFile(rowData, onDownloadComplete);
    }
  };

  return (
    <>
      <span role="button" onClick={handleDownload}>
        <GlobalTooltip tooltip="Download" position="top" className=" text-primary-main float-end me-2">
          <i className={iconClassName} aria-hidden="true" />
        </GlobalTooltip>
      </span>
    </>
  );
}

export default FileDownload;
